/**
 * User actions
 */
import { dispatch } from 'store';

import {
  CONTACT_SET,
  USER_ADDRESS_UPDATED,
  USER_CONTACT_DETAILS_CONFIRMED_PROMPT,
  USER_EMAIL_CONFIRMED_SET,
  USER_LOGIN_LOADING_SET,
  USER_MARKETING_EMAIL_OPT_IN_PROMPT,
  USER_MARKETING_EMAIL_OPT_IN_SET,
  USER_REMOVE,
  USER_SET,
  YAGA_UUID,
} from '../action-types/user.action-types';

// eslint-disable-next-line import/prefer-default-export
export const setUser = (data) => dispatch({ type: USER_SET, data });
export const removeUser = () => dispatch({ type: USER_REMOVE });
export const setLoginLoading = (isLoading: boolean) => dispatch({ type: USER_LOGIN_LOADING_SET, data: isLoading });
export const promptContactDetailsConfirmation = (isContactDetailsConfirmationPrompted: boolean) =>
  dispatch({
    type: USER_CONTACT_DETAILS_CONFIRMED_PROMPT,
    data: isContactDetailsConfirmationPrompted,
  });
export const setEmailConfirmed = (isEmailConfirmed: boolean) => dispatch({ type: USER_EMAIL_CONFIRMED_SET, data: isEmailConfirmed });
export const promptMarketingEmailOptIn = (isConfirmationPrompted: boolean) =>
  dispatch({
    type: USER_MARKETING_EMAIL_OPT_IN_PROMPT,
    data: isConfirmationPrompted,
  });
export const setMarketingEmailOptIn = (optInStatus: boolean) => dispatch({ type: USER_MARKETING_EMAIL_OPT_IN_SET, data: optInStatus });
export const setContact = (data) => dispatch({ type: CONTACT_SET, data });

export const updateUserAddress = (data) => ({ type: USER_ADDRESS_UPDATED, data });

export const setYagaUUID = (data) => dispatch({ type: YAGA_UUID, data });
